<!--  -->
<template>
  <div class="order-container">
    <div class="title">支付方式</div>
    <div class="no-data">您暂未保存支付方式。</div>
    <div class="order-list"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      storeSwiperOption: {
        pagination: { el: ".swiper-pagination", clickable: true },
        loop: false,
        autoplay: false,
        //speed是一张图划过的时间长度
        speed: 200,
        on: {
          slideChangeTransitionStart: function() {
            // _this.componentIndex = this.realIndex;
          }
        }
      }
    };
  },
  components: {},
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    goRouter(_r) {
      this.$router.push({ path: _r });
    }
  }
};
</script>
<style scoped lang='less'>
/* @import url(); 引入css类 */
.order-container {
  .title {
    width: 100%;
    padding: 1.6rem 2rem;
    border-bottom: 0.1rem solid #eaeaea;
    font-size: 1.2rem;
    line-height: 1.67;
  }
  .no-data {
    padding: 1.6rem 2rem;
  }
}

@media screen and (max-width: 1024px) {
  .order-container {
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pay.vue